<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
                <v-card-title>      
                    <v-btn icon @click="gotoReminder">
                    <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                    {{ 'Reminder' | translate }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-form id="form" ref="form">
                        <v-row>
                            <v-col cols="12" sm="8" md="8">
                                <v-row v-if="errors">
                                    <v-col cols="12" sm="12" md="12">
                                    <v-alert
                                        dense
                                        v-for="(v, k) in errors"
                                        :key="k"
                                        outlined
                                        type="error"
                                    >{{ k }} {{ v }}</v-alert>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            outlined
                                            :label="'Subject' | translate"
                                            v-model="subject"
                                            name="subject"
                                            autocomplete="off"
                                            :rules="subjectRules"
                                            required
                                        >
                                        <template #message="{ message }">
                                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                        </template>                            
                                        </v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            outlined
                                            :label="'Email timespan' | translate"
                                            v-model="email_interval"
                                            name="email_interval"
                                            autocomplete="off"
                                            :rules="emailintervalRules"
                                            type="number"
                                            min='1'
                                            required
                                        >
                                        <template #message="{ message }">
                                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                        </template>                            
                                        </v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12" sm="12">
                                    <h3 class="my-3">{{ 'Body' }}</h3>
                                    <tiptap-vuetify name="body"
                                        label="Body"
                                        v-model="body" 
                                        :extensions="extensions"  />
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="4" md="4"></v-col>
                        </v-row>
                    </v-form>
                    <v-btn
                    dark
                    fab
                    fixed
                    bottom
                    right
                    large
                    color="pink"
                    class="mx-2"
                    v-if="email_temp_id != ''"
                    @click="submit"
                    >
                    <v-icon>mdi-content-save</v-icon>
                    </v-btn>
                    <v-btn
                    dark
                    fab
                    fixed
                    bottom
                    right
                    large
                    color="pink"
                    class="mx-2"
                    v-if="email_temp_id"
                    @click="update"
                    >
                    <v-icon>mdi-content-save</v-icon>
                    </v-btn>


                </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>
<script>
import {
  ADD_REMINDER_EMAIL,
  FETCH_INDIVIDUAL_REMINDER_EMAIL,
  UPDATE_REMINDER_EMAIL,
  RESET_STATE
} from "@/store/actions.type";
import {  SET_SNACKBAR, SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History } from 'tiptap-vuetify'
import store from "@/store"
import { mapState } from "vuex"
import { mapGetters } from "vuex"

export default {
    name: "addeditReminderEmail",
  async beforeRouteEnter(to, from, next) {    
    if (to.params.id) {
      await store.dispatch(FETCH_INDIVIDUAL_REMINDER_EMAIL, to.params.id)
      
    }
    store.commit(SET_ROUTER_ENTER, false)

    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(RESET_STATE)
    next();
  },

  components: { TiptapVuetify },
  computed: {
    ...mapGetters(['individualreminderemail', 'curLanguage', 'individualreminderemail']),
    ...mapState({
      errors: state => state.reminderemail.reminderemailerrors
    }),
    subjectRules(){  return [v => !!v || "Subject is required"]},
    emailintervalRules(){ return [v => !!v || "Email timespan is required"]},
    bodyRules(){return [v => !!(v && v.length)|| "Body is required"]},
  },
  created (){
    if(Object.keys(this.individualreminderemail).length > 0){
      this.body = this.individualreminderemail.body
      this.subject = this.individualreminderemail.subject
      this.email_interval = this.individualreminderemail.email_interval
      this.email_temp_id = this.individualreminderemail.email_temp_id
    }    
  },
  data: function(){
      return{
        body : null,
        subject: null,
        email_interval: null,
        email_temp_id: null,
        extensions: [
            [Heading, {
            options: {
                levels: [1, 2, 3,4]
            }
            }],
            Paragraph, 
            BulletList,
            OrderedList,                
            Bold,
            Italic,
            Underline,                       
            Blockquote,        
            Link,
            Strike,
            ListItem,
            HorizontalRule,
            HardBreak,
            History,        
        ],
      }
  },
  methods:{
    gotoReminder(){
        this.$router.push('/reminder')
    },
    submit: function() {
      if (this.$refs.form.validate()) {
        let data = {
            email_type: "signup-reminder",
            subject: this.subject,
            body : this.body,
            email_interval: this.email_interval
          }

        this.$store
          .dispatch(ADD_REMINDER_EMAIL, data)
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'Reminder created successfully'})
              store.commit(SET_LOADING, false)
              this.$router.push({ name: "reminder" });
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    },  
    update: function() {
      if (this.$refs.form.validate()) {
        let data = {
            email_type: "signup-reminder",
            subject: this.subject,
            body : this.body,
            email_interval: this.email_interval,
            email_temp_id:this.email_temp_id,
            _method:"put"
          }  
          
        this.$store
          .dispatch(UPDATE_REMINDER_EMAIL, data)
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'Reminder updated successfully'})
              store.commit(SET_LOADING, false)
              this.$router.push({ name: "reminder" })
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });

      }
    }    
    
  }

}
</script>